export default __webpack_public_path__ + "static/media/rasmika.e0dadd2b.jpg";